import { ObjectState, ProcessMarker } from "../../taskListView/types/tasklListViewProps";

export const getProtocolStatuses = () => {
    return protocol;
}

export const getRegistrationCardStatuses = (processMarker: string, hasGeom: boolean, starostwo: boolean) => {
    if (processMarker === ProcessMarker.N || processMarker === ProcessMarker.A) {
        return processN;
    } else if (processMarker === ProcessMarker.O) {
        if (hasGeom) {
            return processOWithGeom;
        } else {
            return starostwo ? processONoGeomStarostwo : processONoGeom;
        }
    } else if (processMarker === ProcessMarker.K) {
        return processK;
    }
    return [];
}

const EMPTY = { value: 0, nameOnForm: "Zapisz bez zmiany statusu", nameInDb: undefined, colorCode: 0, requiredStates: [] }

// const toCorrect = { value: 1, nameOnForm: "Do poprawy", nameInDb: ObjectState.ToBeCorrected, colorCode: 1, requiredStates: [ObjectState.WaitingRoomEditionVerification, ObjectState.DownloadedForVerification, ObjectState.ToBeVerified] };

const complete = { value: 2, nameOnForm: "Kompletna", nameInDb: ObjectState.Complete, colorCode: 2, requiredStates: [ObjectState.WaitingRoomEdition, ObjectState.DownloadedForEdition, ObjectState.ToBeCorrected] };

const toVerified = (requiredStatuses?: ObjectState[]) => {
    const statuses = requiredStatuses ? requiredStatuses : [ObjectState.Complete];
    return { value: 4, nameOnForm: "Do weryfikacji", nameInDb: ObjectState.ToBeVerified, colorCode: 2, requiredStates: statuses };
};

const accepted = { value: 5, nameOnForm: "Zatwierdzona", nameInDb: ObjectState.Accepted, colorCode: 3, requiredStates: [ObjectState.WaitingRoomEditionVerification, ObjectState.DownloadedForVerification, ObjectState.ToBeVerified] };

// const noGeom = (requiredStatuses?: ObjectState[]) => {
//     const statuses = requiredStatuses ? requiredStatuses : [ObjectState.WaitingRoomEditionVerification, ObjectState.DownloadedForVerification, ObjectState.ToBeVerified];
//     return { value: 3, nameOnForm: "Oczekuje na geometrię", nameInDb: ObjectState.NoGeometry, colorCode: 2, requiredStates: statuses }
// };

const protocol = [
    EMPTY,
    { value: 5, nameOnForm: "Zatwierdzony", nameInDb: ObjectState.Accepted, colorCode: 3, requiredStates: [ObjectState.WaitingRoomEdition, ObjectState.DownloadedForEdition] }
]

const processN = [
    EMPTY,
    // toCorrect,
    complete,
    toVerified(),
    accepted
]

const processOWithGeom = [
    EMPTY,
    // toCorrect,
    complete,
    toVerified(),
    accepted
]

const processONoGeomStarostwo = [
    EMPTY,
    // noGeom(),
    toVerified([ObjectState.WaitingRoomEdition, ObjectState.DownloadedForEdition]),
]

const processONoGeom = [
    EMPTY,
    // noGeom([ObjectState.WaitingRoomEdition, ObjectState.DownloadedForEdition])
]

const processK = [
    EMPTY,
    // toCorrect,
    complete,
    // noGeom(),
    toVerified(),
    accepted
]